<template src="@/templates/reservations/component-list.html"></template>


<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';
import componentView from '@/components/reservations/component-view';
import flightsView from '@/components/reservations/flights-view';

export default {
  props: [
    'travelPackageId',
    'departureId',
    'reservationId',
  ],
  data() {
    return {
      components: [],
      flights: [],
      selectedComponent: null,
      isLoading: true,
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    travelPackageId: 'fetchData',
  },
  methods: {
    selectComponent(component) {
      this.selectedComponent = component;
    },
    fetchData() {
      this.isLoading = true;
      userApi.getReservationComponents(this.reservationId, (data) => {
        data.components.forEach((component) => {
          if (component.type === 'flight') {
            this.flights.push(component);
          } else {
            this.components.push(component);
          }
        });
        this.isLoading = false;
      });
    },
    getIconClass(component) {
      return {
        fa: true,
        'fa-plane': component.type === 'flight',
        'fa-bed': component.type === 'hotel',
        'fa-ship': component.type === 'ship',
        'fa-taxi': component.type === 'pickUp',
        'fa-tree': component.type === 'activity',
        'fa-cube': component.type === 'arrangement',
      };
    },
    formatName(passenger) {
      return entityStore.formatPassengerName(passenger);
    },
  },
  components: {
    componentView,
    flightsView,
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// component-list.vue?29dfe44c